import { render } from "./CalibrationForm.vue?vue&type=template&id=4b63c448&ts=true"
import script from "./CalibrationForm.vue?vue&type=script&lang=ts"
export * from "./CalibrationForm.vue?vue&type=script&lang=ts"

import "./CalibrationForm.vue?vue&type=style&index=0&id=4b63c448&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__